var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChart = function SvgChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.1668 4.16663c-.6416 0-1.1666.525-1.1666 1.16667v9.3333c0 .6417.525 1.1667 1.1666 1.1667.6417 0 1.1667-.525 1.1667-1.1667v-9.3333c0-.64167-.525-1.16667-1.1667-1.16667zm-4.8331 3.50033h-.1667c-.64164 0-1.16664.525-1.16664 1.16667v5.83337c0 .6416.525 1.1666 1.16664 1.1666h.1667c.6417 0 1.1667-.525 1.1667-1.1666v-5.83337c0-.64167-.525-1.16667-1.1667-1.16667zm-6.16684 4.33304c0-.6417.525-1.1667 1.16667-1.1667.64166 0 1.16666.525 1.16666 1.1667v2.6667c0 .6416-.525 1.1666-1.16666 1.1666-.64167 0-1.16667-.525-1.16667-1.1666z",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart.cf1cfe48.svg";
export { ForwardRef as ReactComponent };